import jwtDecode from 'jwt-decode'

import axios from '../axios'

const isValidToken = (accessToken) => {
  if (!accessToken) {
    return false
  }

  return true

  // const decoded = jwtDecode(accessToken)
  // const currentTime = Date.now() / 1000

  // return decoded.exp > currentTime
}

//  const handleTokenExpired = (exp) => {
//   let expiredTimer;

//   window.clearTimeout(expiredTimer);
//   const currentTime = Date.now();
//   const timeLeft = exp * 1000 - currentTime;
//   console.log(timeLeft);
//   expiredTimer = window.setTimeout(() => {
//     console.log('expired');
//     // You can do what ever you want here, like show a notification
//   }, timeLeft);
// };

const setSession = (accessToken) => {
  if (accessToken) {
    localStorage.setItem('adminAccessToken', accessToken)
    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`
    // This function below will handle when token is expired
    // const { exp } = jwtDecode(accessToken);
    // handleTokenExpired(exp);
  } else {
    localStorage.removeItem('adminAccessToken')
    localStorage.removeItem('role')
    delete axios.defaults.headers.common.Authorization
  }
}

const setPhoneNumber = (phoneNumber) => {
  if (phoneNumber) {
    localStorage.setItem('phoneNumber', phoneNumber)
    // This function below will handle when token is expired
    // const { exp } = jwtDecode(accessToken);
    // handleTokenExpired(exp);
  } else {
    localStorage.removeItem('phoneNumber')
  }
}

export { isValidToken, setSession, setPhoneNumber }
